import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Home from './pages/home';
import Login from './pages/login';
import Signup from './pages/signup';
import ResetPassword from './pages/resetPassword';
import Dashboard from './pages/employee/dashboard';
import ServiceForm from './pages/employee/serviceForm';
import ServiceSearch from './pages/employee/serviceSearch';
import EditProfile from './pages/editProfile';
import SearchByPatente from './components/searchByPatente';
import AdminDashboard from './pages/admin/dashboard';

function InvitationHandler({ session, isFromInvitation, children }) {
  const [isCheckingInvitation, setIsCheckingInvitation] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkInvitationToken = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const invitationToken = urlParams.get('token');
      const invitationEmail = urlParams.get('email');
      
      if (invitationToken && invitationEmail) {
        navigate(`/signup?token=${invitationToken}&email=${invitationEmail}`);
        return;
      }
      
      setIsCheckingInvitation(false);
    };

    if (!isFromInvitation) {
      checkInvitationToken();
    } else {
      setIsCheckingInvitation(false);
    }
  }, [navigate, isFromInvitation]);

  if (isCheckingInvitation) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="loading-spinner"></div>
          <p>Verificando invitación...</p>
        </div>
      </div>
    );
  }

  return children;
}

function UserRedirect({ session, userRole, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (session && userRole) {
      if (userRole === 'admin' && location.pathname === '/empleado') {
        navigate('/admin');
      } else if (userRole !== 'admin' && location.pathname === '/admin') {
        navigate('/empleado');
      }
    }
  }, [session, userRole, location.pathname, navigate]);

  return children;
}

export default function AppRouterSimple({ session, userRole, isFromInvitation }) {
  return (
    <Router>
      <InvitationHandler session={session} isFromInvitation={isFromInvitation}>
        <UserRedirect session={session} userRole={userRole}>
          <Routes>
            {/* Página principal */}
            <Route 
              path="/" 
              element={
                session && !isFromInvitation ? (
                  userRole === 'admin' ? 
                    <Navigate to="/admin" /> : 
                    <Navigate to="/empleado" />
                ) : <Home />
              } 
            />

            {/* Login */}
            <Route 
              path="/login" 
              element={
                session && !isFromInvitation ? (
                  userRole === 'admin' ? 
                    <Navigate to="/admin" /> : 
                    <Navigate to="/empleado" />
                ) : <Login onLogin={() => {}} />
              } 
            />

            {/* Signup con invitación */}
            <Route 
              path="/signup" 
              element={
                (() => {
                  const urlParams = new URLSearchParams(window.location.search);
                  const invitationToken = urlParams.get('token');
                  const invitationEmail = urlParams.get('email');
                  
                  if (invitationToken && invitationEmail) {
                    return <Signup />;
                  }
                  
                  if (session && !isFromInvitation) {
                    return userRole === 'admin' ? 
                      <Navigate to="/admin" /> : 
                      <Navigate to="/empleado" />;
                  }
                  
                  return <Signup />;
                })()
              } 
            />

            {/* Reset Password */}
            <Route 
              path="/reset-password" 
              element={
                (() => {
                  const urlParams = new URLSearchParams(window.location.search);
                  const accessToken = urlParams.get('access_token');
                  const type = urlParams.get('type');
                  
                  if (accessToken && type === 'recovery') {
                    return <ResetPassword />;
                  }
                  
                  return <Navigate to="/login" />;
                })()
              } 
            />

            {/* Admin Dashboard */}
            <Route 
              path="/admin" 
              element={
                session && userRole === 'admin' ? 
                  <AdminDashboard /> : 
                  <Navigate to="/login" />
              } 
            />

            {/* Employee Dashboard */}
            <Route 
              path="/empleado" 
              element={
                session ? <Dashboard /> : <Navigate to="/" />
              }
            >
              <Route index element={<ServiceForm />} />
              <Route path="busquedas" element={<ServiceSearch />} />
            </Route>

            {/* Editar Service - ruta global (Opción A) */}
            <Route 
              path="/edit-service/:id" 
              element={session ? <ServiceForm user={session?.user} /> : <Navigate to="/login" />} 
            />

            {/* Edit Profile - accesible desde cualquier parte si está logueado */}
            <Route 
              path="/perfil" 
              element={
                session ? <EditProfile /> : <Navigate to="/login" />
              } 
            />

            {/* Búsqueda pública */}
            <Route path="/buscar" element={<SearchByPatente />} />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </UserRedirect>
      </InvitationHandler>
    </Router>
  );
}
